var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-item-group',{attrs:{"item":_vm.item,"sub-group":"","text":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }